<template>

        <el-dialog :visible.sync="visible" :close-on-click-modal="false" :before-close="close" append-to-body
                   width="750px">
            <div slot="title">
                <z-title :title="title"></z-title>
            </div>
            <div class="extraitem plr-20">
                <div class="haschoose" v-if="title=='修改套餐'">已选套餐：{{packageName}}</div>
                <el-button type="primary" class="btn ele-btn-small" @click="add">自定义</el-button>
                <el-tabs v-model="activeName">
                    <el-tab-pane label="额外项目" name="1">
                        <el-row>
                            <el-col class="left" :span="7">
                                <el-tree ref="eltree2" :data="itemsExTree" node-key="itemId" :props="exTreeProps"
                                         show-checkbox @check-change="handleCheckChange2"></el-tree>
                            </el-col>
                            <el-col class="right" :span="17">
                                <div>项目名称</div>
                                <div class="item">
                                    <div v-for="item,index in itemsList" class="flex-n fac fjb mt-10">
                                        <template v-if="!item.isManual">
                                            <div class="w-120"
                                                 :style="{'color':item.isChange=='1'?'#cf9236!important':''}">
                                                {{item.itemName}}
                                            </div>
                                            <div class="mr-10 textnowrap">单价</div>
                                            <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"
                                                             v-model="item.itemPrice" :controls="false"
                                                             :min="0" :precision="2"></el-input-number>
                                            <div class="mr-10 textnowrap">数量</div>
                                            <el-input-number size="medium" class="w-60 mr-10" v-model="item.itemCount"
                                                             :controls="false"
                                                             :min="1"></el-input-number>
                                            <el-button type="primary" class="ele-btn-small" size="medium"
                                                       @click="remove(item,index,0)">-
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <el-input placeholder="输入名称" size="medium" class="mr-10 w-110"
                                                      v-model="item.itemName"
                                            ></el-input>
                                            <div class="mr-10 textnowrap">单价</div>
                                            <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"
                                                             v-model="item.itemPrice" :controls="false"
                                                             :min="0" :precision="2"></el-input-number>
                                            <div class="mr-10 textnowrap">数量</div>
                                            <el-input-number size="medium" class="w-60 mr-10" v-model="item.itemCount"
                                                             :controls="false"
                                                             :min="1"></el-input-number>
                                            <el-button type="primary" class="ele-btn-small" size="medium"
                                                       @click="remove(item,index,0)">-
                                            </el-button>
                                        </template>
                                    </div>
                                </div>
                                <div class="flex-n fac fjb mt-10" v-if="title!='修改套餐'">
                                    <div>应收价格：{{totalprice}}</div>
                                    <div class="flex-n fac">
                                        <div class="mr-10">实际价格</div>
                                        <el-input-number size="medium" class="mr-10 w-120" v-model="nowPrice"
                                                         :controls="false"
                                                         :min="0" :precision="2" :step="0.1"
                                                         :max="9999999999"></el-input-number>
                                        <div>元</div>
                                    </div>
                                </div>
                                <div class="flex-n fac fje mt-10" v-else>应收价格：{{totalprice}}元</div>
                            </el-col>
                        </el-row>

                    </el-tab-pane>
                    <el-tab-pane label="点餐项目" v-if="!isWedding" name="2">
                        <el-row>
                            <el-col class="left" :span="7">
                                <el-tree ref="eltree" :data="itemsFoodTree" node-key="foodId" :props="foodTreeProps"
                                         show-checkbox @check-change="handleCheckChange"></el-tree>
                            </el-col>
                            <el-col class="right" :span="17">
                                <div>菜品名称</div>
                                <div class="item">
                                    <div v-for="item,index in foodsList" class="flex-n fac fjb mt-10">
                                        <template v-if="!item.isManual">
                                            <div class="w-120"
                                                 :style="{'color':item.isChange=='1'?'#cf9236!important':''}">
                                                {{item.foodName}}
                                            </div>
                                            <div class="mr-10 textnowrap">单价</div>
                                            <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"
                                                             v-model="item.foodPrice" :controls="false"
                                                             :min="0" :precision="2"></el-input-number>
                                            <div class="mr-10 textnowrap">数量</div>
                                            <el-input-number size="medium" class="w-60 mr-10" v-model="item.foodCount"
                                                             :controls="false"
                                                             :min="1"></el-input-number>
                                            <el-button type="primary" class="ele-btn-small" size="medium"
                                                       @click="remove(item,index,1)">-
                                            </el-button>
                                        </template>
                                        <template v-else>
                                            <el-input placeholder="输入名称" size="medium" class="mr-10 w-110"
                                                      v-model="item.foodName"
                                            ></el-input>
                                            <div class="mr-10 textnowrap">单价</div>
                                            <el-input-number placeholder="价格" size="medium" class="mr-10 w-120"
                                                             v-model="item.foodPrice" :controls="false"
                                                             :min="0" :precision="2"></el-input-number>
                                            <div class="mr-10 textnowrap">数量</div>
                                            <el-input-number size="medium" class="w-60 mr-10" v-model="item.foodCount"
                                                             :controls="false"
                                                             :min="1"></el-input-number>
                                            <el-button type="primary" class="ele-btn-small" size="medium"
                                                       @click="remove(item,index,1)">-
                                            </el-button>
                                        </template>
                                    </div>
                                </div>
                                <div class="flex-n fac fjb mt-10" v-if="title!='修改套餐'">
                                    <div>应收价格：{{totalprice}}</div>
                                    <div class="flex-n fac">
                                        <div class="mr-10">实际价格</div>
                                        <el-input-number size="medium" class="mr-10 w-120" v-model="nowPrice"
                                                         :controls="false"
                                                         :min="0" :precision="2" :step="0.1"
                                                         :max="9999999999"></el-input-number>
                                        <div>元</div>
                                    </div>
                                </div>
                                <div class="flex-n fac fje mt-10" v-else>应收价格：{{totalprice}}元</div>
                            </el-col>
                        </el-row>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <div class="flex-n fjc fac mt-10">
                <el-button type="primary" class="mr-20" @click="makesure">确 定</el-button>
                <el-button @click="close">取 消</el-button>
            </div>
        </el-dialog>

</template>

<script>
    import ZTitle from "../../components/ZTitle";

    export default {
        components: {ZTitle},
        name: "extraList",
        props: {
            visible: Boolean,
            title: String,
            packageName: String,
            packageId: String,
            data: Object,
            havepackage: Boolean,
            //婚庆隐藏套餐
            isWedding: Boolean
        },
        model: {
            prop: 'data',
            event: 'input'
        },
        computed: {
            totalprice() {
                var money = 0;
                for (var i in this.foodsList) {
                    money += this.foodsList[i].foodPrice * this.foodsList[i].foodCount;
                }
                for (var i in this.itemsList) {
                    money += this.itemsList[i].itemPrice * this.itemsList[i].itemCount;
                }
                this.nowPrice = money.toFixed(2);
                return money.toFixed(2);
            }
        },
        data() {
            return {
                activeName: '1',
                state: 0,
                itemsFoodTree: [],
                itemsExTree: [],//读取的额外项目节点
                itemsList: [],//额外项目选中
                foodsList: [],//点餐项目选中
                nowPrice: 0,
                exTreeProps: {
                    label: 'itemName',
                    children: 'itemsExs',
                },
                foodTreeProps: {
                    label: 'foodName',
                    children: 'itemsFoods',
                },
                olditemsList: [],
                oldfoodsList: []
            }
        },
        watch: {
            data: {
                deep: true,
                immediate:true,
                handler(newval, oldval) {
                    if(newval){
                        console.log('修改套餐', newval, oldval)
                        this.itemsList = newval.itemsExTree||[];
                        this.foodsList = newval.itemsFoodTree||[];
                    }

                }
            },
            visible(newval, oldval) {
                if (newval) {
                    console.log(this.isWedding)
                    if (this.isWedding) {
                        this.olditemsList = this.itemsList;
                        this.activeName = '1';
                        this.getitemsExTree();
                    } else {
                        this.olditemsList = this.itemsList;
                        this.oldfoodsList = this.foodsList;
                        this.activeName = '1';
                        this.getitemsExTree();
                        this.getitemsFoodTree();
                    }

                }
            }
        },
        methods: {
            //获取额外项目树
            getitemsExTree() {
                this.$axios.post('/itemsEx/itemsExTreeByStoreId', {
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    console.log('额外项目树', res)
                    var itemsExTree = res.data.itemsExTree;
                    for (var i in itemsExTree) {
                        itemsExTree[i].itemName = itemsExTree[i].itemTypeName
                        for (var j in itemsExTree[i].itemsExs) {
                            itemsExTree[i].itemsExs[j].itemCount = 1;
                            if (this.title == '修改套餐')
                                itemsExTree[i].itemsExs[j].isChange = '1';
                            else
                                itemsExTree[i].itemsExs[j].isChange = '0';
                            itemsExTree[i].itemsExs[j].itemId = itemsExTree[i].itemsExs[j].id;
                            if (this.havepackage) {
                                itemsExTree[i].itemsExs[j].packageId = itemsExTree[i].itemTypeCode
                            }
                        }
                        if (itemsExTree[i].itemsExs.length == 0) {
                            itemsExTree[i].disabled = true;
                        }
                    }
                    for (var i in this.itemsList) {
                        for (var j in itemsExTree) {
                            for (var k in itemsExTree[j].itemsExs) {
                                if (this.itemsList[i].itemId == itemsExTree[j].itemsExs[k].itemId) {
                                    itemsExTree[j].itemsExs[k].isChange = this.itemsList[i].isChange;
                                    break;
                                }
                            }
                        }
                    }
                    this.itemsExTree = itemsExTree;
                    if (this.visible) {
                        var idlist = [];
                        for (var i in this.itemsList) {
                            idlist.push(this.itemsList[i].itemId)
                            if (this.itemsList[i].isManual != 1) {
                                this.itemsList[i].isManual = 0;
                            }
                        }
                        this.$refs.eltree2.setCheckedKeys(idlist);
                    }
                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            getitemsFoodTree() {
                this.$axios.post('/itemsFood/itemsFoodTreeByStoreId', {
                    "storeId": this.$root.getStorage('storeId')
                }).then(res => {
                    console.log('套餐项目树', res)
                    var itemsFoodTree = res.data.itemsFoodTree;
                    for (var i in itemsFoodTree) {
                        itemsFoodTree[i].foodName = itemsFoodTree[i].foodTypeName
                        for (var j in itemsFoodTree[i].itemsFoods) {
                            itemsFoodTree[i].itemsFoods[j].foodCount = 1;
                            if (this.title == '修改套餐')
                                itemsFoodTree[i].itemsFoods[j].isChange = '1';
                            else
                                itemsFoodTree[i].itemsFoods[j].isChange = '0';
                            itemsFoodTree[i].itemsFoods[j].foodId = itemsFoodTree[i].itemsFoods[j].id;
                            if (this.havepackage) {
                                itemsFoodTree[i].itemsFoods[j].packageId = itemsFoodTree[i].foodTypeCode
                            }
                        }
                        if (itemsFoodTree[i].itemsFoods.length == 0) {
                            itemsFoodTree[i].disabled = true;
                        }
                    }
                    for (var i in this.foodsList) {
                        for (var j in itemsFoodTree) {
                            for (var k in itemsFoodTree[j].itemsFoods) {
                                if (this.foodsList[i].foodId == itemsFoodTree[j].itemsFoods[k].foodId) {
                                    itemsFoodTree[j].itemsFoods[k].isChange = this.foodsList[i].isChange;
                                    break;
                                }
                            }
                        }
                    }
                    this.itemsFoodTree = itemsFoodTree;
                    if (this.visible) {
                        var idlist = [];
                        for (var i in this.foodsList) {
                            idlist.push(this.foodsList[i].foodId)
                            if (this.foodsList[i].isManual != 1) {
                                this.foodsList[i].isManual = 0;
                            }
                        }
                        this.$refs.eltree.setCheckedKeys(idlist);
                    }

                }).catch(err => {
                    this.$message.error(err.msg);
                })
            },
            close() {
                this.itemsList = this.olditemsList;
                this.foodsList = this.oldfoodsList;
                this.$emit('update:visible', false)
            },
            remove(item, index, state) {
                if (state == 0) {
                    this.itemsList.splice(index, 1);
                    item.itemCount = 1;
                    this.$refs.eltree2.setChecked(item, false);
                } else {
                    this.foodsList.splice(index, 1);
                    item.foodCount = 1;
                    this.$refs.eltree.setChecked(item, false);
                }


            },
            handleCheckChange() {
                var a = this.$refs.eltree.getCheckedNodes(true);//只要叶子节点
                console.log(a)
                var arr = [];
                console.log('foodList',this.foodsList)
                var newArr =  this.foodsList.filter(item =>{return item.isManual} );

                console.log(newArr)
                a.forEach((item) => {
                    for (var i in this.foodsList) {
                        if (this.foodsList[i] == item) {
                            break;
                        }
                        if (this.foodsList[i] != item && i == this.foodsList.length - 1) {
                            item.foodCount = 1;
                        }
                    }
                    arr.push(item)
                })
                this.foodsList = arr.concat(newArr);
            },
            handleCheckChange2() {
                var a = this.$refs.eltree2.getCheckedNodes(true);//只要叶子节点
                console.log('叶子节点',a)
                var arr = [];
                var newArr = this.itemsList.filter(item =>{return item.isManual})
                console.log(newArr)
                a.forEach((item) => {
                    for (var i in this.itemsList) {
                        if (this.itemsList[i] == item) {
                            break;
                        }
                        if (this.itemsList[i] != item && i == this.itemsList.length - 1) {
                            item.itemCount = 1;
                        }
                    }
                    arr.push(item)
                })

                console.log(arr)
                this.itemsList = arr.concat(newArr);
            },
            add() {
                if (this.havepackage) {
                    if (this.activeName == '1') {
                        this.itemsList.unshift({
                            isManual: 1,
                            itemName: '',
                            itemPrice: '',
                            itemId: '',
                            packageId: this.packageId,
                            itemCount: 1
                        })
                    } else {
                        this.foodsList.unshift({
                            isManual: 1,
                            foodName: '',
                            foodPrice: '',
                            foodId: '',
                            packageId: this.packageId,
                            foodCount: 1
                        })
                    }
                } else {
                    if (this.activeName == '1') {
                        this.itemsList.unshift({
                            isManual: 1,
                            itemName: '',
                            itemPrice: '',
                            itemId: '',
                            itemCount: 1
                        })
                    } else {
                        this.foodsList.unshift({
                            isManual: 1,
                            foodName: '',
                            foodPrice: '',
                            foodId: '',
                            foodCount: 1
                        })
                    }
                }

            },
            makesure() {
                var data = {};
                data = {
                    itemsExTree: this.itemsList,
                    itemsFoodTree: this.foodsList
                }
                this.$emit('input', data)
                this.$emit('getTotal', {'totalprice': this.totalprice, 'nowPrice': this.nowPrice});
                this.$emit('update:visible', false)
            },
            resetCard() {
                this.itemsList = [];
                this.foodsList = [];
            },
        }
    }
</script>

<style scoped lang="scss">
    .extraitem {
        position: relative;
        .haschoose {
            position: absolute;
            top: 15px;
            z-index: 9999;
            right: 90px;
        }
        .btn {
            position: absolute;
            top: 10px;
            z-index: 9999;
            right: 20px;
        }
        .left {
            border-right: 1px solid #eee;
            height: 260px;
            overflow-y: scroll;
        }
        .right {
            .item {
                height: 200px;
                overflow-y: scroll;
            }
            padding-left: 20px;
        }
    }
</style>
